import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'submit', 'input' ];

  connect(){
    this.onChange();
  }

  onChange() {
    const valid = this.inputTargets.every(input => input.value.length > 0);
    ( valid ) ? this.enableSubmit() : this.disableSubmit();
  }

  disableSubmit() {
    this.submitTarget.disabled = true;
    this.submitTarget.classList.add('--disabled');
  }

  enableSubmit() {
    this.submitTarget.disabled = false;
    this.submitTarget.classList.remove('--disabled');
  }
}
